import API from '../services/api';
import { documentationFeatureFlag } from './featureFlag';

export const getDocumentationAvailability = async () => {
  try {
    const result = await API.getActiveFeatureFlag(documentationFeatureFlag);
    return result?.active === true;
  } catch (error) {
    return false;
  }
};
